module.exports = __webpack_public_path__ + "static/media/code-merge.ee611406.svg";